import React , { Component } from "react";

export default class Footer extends Component {
    render() {
        return (
            
            <div>
                 <footer class="footer">
        <div class="footer-text">
            <p>Copyright &copy; 2023 by Anord | All Rights Reserved.</p>
        </div>
        <div class="footer-iconTop">
            <a href="#home"> <i class="bx bx-up-arrow-alt"></i></a>
        </div>
    </footer>
            </div>
        )
      }
}